function TrustedAdvisorPage() {
    return (
        <div>
            Trusted Advisor page
        </div>
    )
}

export default TrustedAdvisorPage;
